import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-633b45a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "receipt-container" }
const _hoisted_2 = { class: "receipt-header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-center font-bold text-base mb-1" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "text-center text-sm" }
const _hoisted_7 = { class: "text-center text-sm" }
const _hoisted_8 = { class: "flex flex-col items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[16px] text-center font-bold mt-1 mb-1" }, " Date rapport ", -1))
const _hoisted_10 = { class: "flex flex-row gap-2" }
const _hoisted_11 = { class: "text-center text-sm" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-center text-sm" }, " - ", -1))
const _hoisted_13 = { class: "text-center text-sm" }
const _hoisted_14 = { class: "receipt-content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[16px] text-center font-bold mt-2 mb-2" }, " RAPPORT DE VENTE PAR ARTICLE ", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-b border-dashed border-gray-200" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left py-2 font-bold" }, "Qté"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left py-2 font-bold" }, "ARTICLE"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right py-2 font-bold" }, "Total")
  ])
], -1))
const _hoisted_19 = { class: "text-left" }
const _hoisted_20 = { class: "text-left" }
const _hoisted_21 = { class: "text-right" }
const _hoisted_22 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_23 = { class: "mt-4 border-t border-dashed border-gray-200" }
const _hoisted_24 = { class: "flex justify-between pt-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "TOTAL HT ", -1))
const _hoisted_26 = { class: "flex justify-between" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "TOTAL TVA", -1))
const _hoisted_28 = { class: "flex justify-between" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "TOTAL TTC", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[16px] text-center font-bold mt-2 mb-2" }, " RAPPORT DE VENTE PAR GROUPE ", -1))
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { class: "w-full" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-b border-dashed border-gray-200" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left py-2 font-bold" }, "Qté"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left py-2 font-bold" }, "Groupe"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right py-2 font-bold" }, "Total")
  ])
], -1))
const _hoisted_34 = { class: "text-left" }
const _hoisted_35 = { class: "text-left" }
const _hoisted_36 = { class: "text-right" }
const _hoisted_37 = {
  key: 3,
  class: "text-center py-4"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[16px] text-center font-bold mt-2 mb-2" }, " RAPPORT DE STOCK ", -1))
const _hoisted_39 = { key: 4 }
const _hoisted_40 = { class: "w-full" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-b border-dashed border-gray-200" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left py-2 font-bold" }, "Article"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right py-2 font-bold" }, "Qté")
  ])
], -1))
const _hoisted_42 = { class: "text-left" }
const _hoisted_43 = { class: "text-right" }
const _hoisted_44 = {
  key: 5,
  class: "text-center py-4"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[16px] text-center font-bold mt-2 mb-2" }, " RAPPORT DE CAISSE ", -1))
const _hoisted_46 = { key: 6 }
const _hoisted_47 = { class: "flex justify-between" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Montant d'ouverture ", -1))
const _hoisted_49 = { class: "flex justify-between" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Vente en espèces ", -1))
const _hoisted_51 = { class: "flex justify-between" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Vente autre ", -1))
const _hoisted_53 = { class: "flex justify-between" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Montant prévue", -1))
const _hoisted_55 = { class: "receipt-footer mt-2 pt-2 border-t border-dashed border-gray-200" }
const _hoisted_56 = { class: "text-center text-xs" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-center text-sm" }, " POSYS - Point Of Sale System ", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center text-sm" }, "www.posys.io", -1))

import dayjs from "dayjs";

import { PrinterOutlined } from "@ant-design/icons-vue";

import { ref } from "vue";

import {
  defineComponent,
  defineProps,
  defineEmits,
  onMounted,
  watch,
  computed,
  onUnmounted,
} from "vue";

const __default__ = defineComponent({
  name: "LbrxPreviewModal",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    open: { type: Boolean },
    data: {},
    posConfig: {},
    dateRange: {}
  },
  emits: ["update:open", "print-report"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const open = ref(props.open);
watch(
  () => props.open,
  (newValue) => {
    open.value = newValue;
  }
);
watch(open, (newValue) => {
  emit("update:open", newValue);
});

const windowWidth = ref(window.innerWidth);

const modalWidth = computed(() => {
  // extra small devices
  if (windowWidth.value < 576) {
    return '100%'; 
  }
  // small devices 
  else if (windowWidth.value >= 576 && windowWidth.value < 768) {
    return '60%';
  }
  // medium devices 
  else if (windowWidth.value >= 768 && windowWidth.value < 992) {
    return 320;
  }
  // large devices 
  else if (windowWidth.value >= 992 && windowWidth.value < 1200) {
    return 420;
  }
  // extra large devices
  else {
    return 600;
  }
});

const handleResize = () => {
  windowWidth.value = window.innerWidth;
};

const formatDate=(date:any)=>{
  return dayjs(date).format("DD/MM/YYYY HH:mm");
}
const formattedDate=()=>{
  return dayjs().format("YYYY/MM/DD HH:mm");
}

const printReport = () => {
  emit("print-report", props.data);
};


onMounted(() => {
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});


return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    open: open.value,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((open).value = $event)),
    class: "custom-class",
    "root-class-name": "root-class-name",
    width: modalWidth.value
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_a_button, {
          class: "print-btn",
          onClick: printReport
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(PrinterOutlined))
          ]),
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("Pos.Print")) + " ", 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.posConfig?.store.logo,
            class: "logo"
          }, null, 8, _hoisted_3),
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.posConfig?.store.name), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.posConfig?.store.address), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.posConfig?.store.phone), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(formatDate(_ctx.dateRange[0])), 1),
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(formatDate(_ctx.dateRange[1])), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          (_ctx.data?.categories?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("table", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.products, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id
                      }, [
                        _createElementVNode("td", _hoisted_19, _toDisplayString(item.quantity || "0"), 1),
                        _createElementVNode("td", _hoisted_20, _toDisplayString(item.name), 1),
                        _createElementVNode("td", _hoisted_21, _toDisplayString(item.total), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_22, "Aucun article disponible.")),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("span", null, _toDisplayString(_ctx.data.sub_total_revenue), 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("span", null, _toDisplayString(_ctx.data.total_vat), 1)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("span", null, _toDisplayString(_ctx.data.total_revenue), 1)
            ])
          ]),
          _hoisted_30,
          (_ctx.data?.categories?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("table", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.categories, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id
                      }, [
                        _createElementVNode("td", _hoisted_34, _toDisplayString(item.quantity || "0"), 1),
                        _createElementVNode("td", _hoisted_35, _toDisplayString(item.name), 1),
                        _createElementVNode("td", _hoisted_36, _toDisplayString(item.total), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_37, "Aucun article disponible.")),
          _hoisted_38,
          (_ctx.data?.stock?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createElementVNode("table", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.stock, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id
                      }, [
                        _createElementVNode("td", _hoisted_42, _toDisplayString(item.stockable?.name || "Unknown"), 1),
                        _createElementVNode("td", _hoisted_43, _toDisplayString(item.quantity) + " " + _toDisplayString(item.unit), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_44, " Aucun article en stock disponible. ")),
          _hoisted_45,
          (_ctx.data?.drawerInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("span", null, _toDisplayString(_ctx.data.drawerInfo.opening_amount), 1)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("span", null, _toDisplayString(_ctx.data.drawerInfo.total_cash_payment), 1)
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createElementVNode("span", null, _toDisplayString(_ctx.data.drawerInfo.total_other_methods), 1)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("span", null, _toDisplayString(_ctx.data.drawerInfo.total_cash), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("p", _hoisted_56, _toDisplayString(formattedDate()), 1),
          _hoisted_57,
          _hoisted_58
        ])
      ])
    ]),
    _: 1
  }, 8, ["open", "width"]))
}
}

})